import { indexes } from '@mab-common/utils'

import type { QueryDslQueryContainer } from '@elastic/elasticsearch/lib/api/types'

import {
  buildElasticSearchTerm,
  buildElasticSortFields,
} from '~/services/elastic/builder'
import { useElasticQuery } from '~/services/query/use-elastic-query'

import { MIN_SCORES } from './constants'
import EsIndexTypes = indexes.EsIndexTypes
import RecordTypes = indexes.RecordTypes

export default function useSelectBox(
  searchTerm: string,
  indexName: EsIndexTypes.ARTIST | EsIndexTypes.ARTWORKS,
  dataType:
    | RecordTypes.ARTIST_SELECT_LIST
    | RecordTypes.ARTWORK_SELECT_LIST
    | RecordTypes.ALL_ARTWORK_SELECT_LIST,
  pageSize = 9,
  filters: QueryDslQueryContainer[] = []
) {
  return useElasticQuery<any>(dataType, {
    index: indexName,
    searches: [
      {},
      {
        size: pageSize,
        sort: buildElasticSortFields(dataType),
        query: {
          bool: {
            must_not: [
              {
                term: {
                  isVisible: false,
                },
              },
            ],
            filter: filters,
            must: buildElasticSearchTerm(dataType, searchTerm),
          },
        },
        min_score: MIN_SCORES.SELECT_BOX,
      },
    ],
  })
}
